module.exports = __webpack_public_path__ + "static/media/icon_speaker_off.8c6ee2f2.svg";